import { OrderModel } from 'models/order';

export default function checkIsProcessingOrder(ordersInProcess: number[]) {
  return (order: OrderModel) => ordersInProcess.some(orderId => orderId === order.id);
}
